/*!
 * handlebars2 v1.0.9
 * (c) 2016-present chl814@foxmail.com
 */
import Codemirror from 'codemirror';
import 'codemirror/lib/codemirror.css';
import 'codemirror/mode/meta';

/**
 * find mode for CodeMirror
 *
 * @param mode
 * @returns {*}
 */
function findMode(CodeMirror, mode) {
  var lang;
  // mode string config
  if (typeof mode == 'string') {
    lang = CodeMirror.findModeByMIME(mode);
    mode = !lang ? lang : lang.mode;

    // mode object config
  } else if (typeof mode == 'object') {
    if (mode.name) {
      lang = CodeMirror.findModeByName(mode.name);
      if (lang) {
        mode = lang.mode;
      } else {
        mode = null;
      }
    } else if (mode.ext) {
      lang = CodeMirror.findModeByExtension(mode.ext);
      if (lang) {
        mode = lang.mode;
      } else {
        mode = null;
      }
    } else if (mode.mime) {
      lang = CodeMirror.findModeByMIME(mode.mime);
      if (lang) {
        mode = lang.mode;
      } else {
        mode = null;
      }
    } else if (mode.filename) {
      lang = CodeMirror.findModeByFileName(mode.filename);
      if (lang) {
        mode = lang.mode;
      } else {
        mode = null;
      }
    }
  }
  return mode;
}

/**
 * transform array-like to array
 *
 * @param arrayLike
 * @return {*}
 */

var defaultConfig = {
  'theme': 'monokai',
  'mode': 'text/javascript'
};

var themeList = ['default', '3024-day', '3024-night', 'abcdef', 'ambiance', 'base16-dark', 'base16-light', 'bespin', 'blackboard', 'cobalt', 'colorforth', 'dracula', 'duotone-dark', 'duotone-light', 'eclipse', 'elegant', 'erlang-dark', 'hopscotch', 'icecoder', 'isotope', 'lesser-dark', 'liquibyte', 'material', 'mbo', 'mdn-like', 'midnight', 'monokai', 'neat', 'neo', 'night', 'panda-syntax', 'paraiso-dark', 'paraiso-light', 'pastel-on-dark', 'railscasts', 'rubyblue', 'seti', 'solarized dark', 'solarized light', 'the-matrix', 'tomorrow-night-bright', 'tomorrow-night-eighties', 'ttcn', 'twilight', 'vibrant-ink', 'xq-dark', 'xq-light', 'yeti', 'zenburn'];

var events = ['changes', 'beforeChange', 'cursorActivity', 'keyHandled', 'inputRead', 'electricInput', 'beforeSelectionChange', 'viewportChange', 'swapDoc', 'gutterClick', 'gutterContextMenu', 'focus', 'blur', 'refresh', 'optionChange', 'scrollCursorIntoView', 'update'];

var VCodemirror = {

  template: "<div class=\"V-Codemirror\" style=\"height: 100%; width: 100%\">\n                <textarea ref=\"editor\"></textarea>\n            </div>",

  name: 'V-Codemirror',

  props: {
    value: String,
    marker: Function,
    unseenLines: Array,
    options: Object
  },

  data: function data() {
    return {
      opts: {
        showToolkit: true,
        theme: defaultConfig.theme,
        mode: defaultConfig.mode,
        tabSize: 2
      },
      themeList: themeList
    };
  },

  created: function created() {
    this.setOption(this.options);
    this.loadDependencies(this.opts);
  },

  mounted: function mounted() {
    this.initialize(this.opts);
  },

  beforeDestroy: function beforeDestroy() {
    this.recycleEditor();
  },

  watch: {
    value: function value(newVal) {
      if (newVal !== this.editor.getValue()) {
        var scrollInfo = this.editor.getScrollInfo();
        this.editor.setValue(newVal);
        this.value = newVal;
        this.editor.scrollTo(scrollInfo.left, scrollInfo.top);
      }
      this.unseenLineMarkers();
    }
  },

  methods: {

    refresh: function refresh() {
      this.editor.refresh();
    },

    undo: function undo() {
      this.editor.undo();
    },

    redo: function redo() {
      this.editor.redo();
    },

    setOption: function setOption(opts) {
      if (typeof opts === 'object') {
        this.opts = Object.assign({}, this.opts, opts);
      } else if (arguments.length >= 2) {
        this.opts[arguments[0]] = arguments[1];
      } else {
        console.warn(("Invalid editor option: " + opts));
      }
    },

    updateEditor: function updateEditor() {
      this.recycleEditor();
      this.loadDependencies(this.opts);
      this.initialize(this.opts);
    },

    recycleEditor: function recycleEditor() {
      var element = this.editor.doc.cm.getWrapperElement();
      if (element && element.remove) {
        element.remove();
      }
    },

    unseenLineMarkers: function unseenLineMarkers() {
      var this$1 = this;

      if (this.unseenLines !== undefined && this.marker !== undefined) {
        this.unseenLines.forEach(function (line) {
          var info = this$1.editor.lineInfo(line);
          this$1.editor.setGutterMarker(line, 'breakpoints', info.gutterMarkers ? null : this$1.marker());
        });
      }
    },

    loadDependencies: function loadDependencies(opts) {
      var options = opts;
      var isCustomMode = !!Codemirror.modes[mode];
      var theme = options.theme;
      var mode = options.mode;

      // theme config
      if (theme && theme == 'solarized light') {
        theme = 'solarized';
      }

      mode = findMode(Codemirror, mode);

      if ((!mode || mode == 'null') && !isCustomMode) {
        console.warn('CodeMirror language mode: ' + mode + ' configuration error (CodeMirror language mode configuration error，or unsupported language) refer to http://codemirror.net/mode/ for more details.');
      }

      // require language
      if (mode && mode !== 'null') {
        require('codemirror/mode/' + mode + '/' + mode + '.js');
      }

      // require theme
      if (theme) {
        require('codemirror/theme/' + theme + '.css');
      }
    },

    initialize: function initialize(editorOpts) {
      var this$1 = this;

      this.editor = Codemirror.fromTextArea(this.$refs.editor, editorOpts);
      this.editor.setValue(this.code || this.value);
      this.editor.on('change', function (cm) {
        //                    this.value = cm.getValue()
        var val = cm.getValue();
        if (this$1.$emit) {
          this$1.$emit('input', val);
          this$1.$emit('change', val);
        }
      });
      events.forEach(function (event) {
        this$1.editor.on(event, function (a, b, c) {
          this$1.$emit(event, a, b, c);
        });
      });
      this.$emit('ready', this.editor);
      this.unseenLineMarkers();

      // prevents funky dynamic rendering
      window.setTimeout(function () {
        this$1.editor.refresh();
      }, 0);
    }
  }
};

function install(Vue) {
  Vue.component(VCodemirror.name, VCodemirror);
}

var findModeByMIME = Codemirror.findModeByMIME;
var findModeByExtension = Codemirror.findModeByExtension;
var findModeByFileName = Codemirror.findModeByFileName;
var findModeByName = Codemirror.findModeByName;

export { VCodemirror, themeList as THEME, findMode, findModeByMIME, findModeByExtension, findModeByFileName, findModeByName };
export default install;
